// extracted by mini-css-extract-plugin
export default {"title":"UeGY6sNQxFVEE5L8tf1R"};